import $ from 'jquery';

export default function () {
    $('#dropzoneCurvePoints').on('addedfile', function () {
        $('#import-submit-form-btn').removeAttr('disabled');
    });

    $('#dropzoneCurvePoints').on('removedfile', function () {
        $('#import-submit-form-btn').attr('disabled');
    });
};


// WEBPACK FOOTER //
// ./App/components/modules/curvePointImport.js